/** @jsxImportSource @emotion/react */
import errorImg from '../../../assets/icons/failureTriangle.svg';
import errorImgRed from '../../../assets/icons/failureTriangleRed.svg';
import successImg from '../../../assets/icons/checkCircle.svg';
import noDataImg from '../../../assets/icons/warningTriangleSunsetGold.svg';
import { BoxedMessageStyle } from './boxedMessageStyle';
import { css } from '@emotion/react';
import { BLUE_CREEK, RED_CREEK, WHITE } from '../../../styles/colors';

/*
 * These are preset styles to apply to StyledBoxedMessage for commonly-used situations.
 */

export const BoxedSuccessMessage: BoxedMessageStyle = {
  imgAlt:          'Success',
  image:           successImg,
  backgroundColor: BLUE_CREEK,
  textColor:       WHITE,
};

export const BoxedNoDataMessage: BoxedMessageStyle = {
  imgAlt:          'NoData',
  image:           noDataImg,
  backgroundColor: 'transparent',
  textColor:       BLUE_CREEK,
  rootCss:       css`
    box-sizing: border-box;
    border: 1px solid ${BLUE_CREEK};
    border-radius: 5px;
  `,
};

export const BoxedErrorMessageDefault: BoxedMessageStyle = {
  imgAlt:          'Error',
  image:           errorImg,
  backgroundColor: RED_CREEK,
  textColor:       WHITE,
};

export const BoxedErrorInverse: BoxedMessageStyle = {
  imgAlt:          'Error',
  image:           errorImgRed,
  backgroundColor: 'transparent',
  textColor:       RED_CREEK,
  rootCss:       css`
    box-sizing: border-box;
    border: 1px solid ${RED_CREEK};
    border-radius: 5px;
  `,
};

export const BoxedErrorInverseNoBorder: BoxedMessageStyle = {
  imgAlt:          'Error',
  image:           errorImgRed,
  backgroundColor: 'transparent',
  textColor:       RED_CREEK,
  rootCss:       css`
    padding: 0;
    
    div { 
      padding: 0;
    }
    
    p { 
      margin-bottom: 0;
      margin-block-end: 0;
    }
  `,
};
